import { apiSlice } from "./apiSlice";

export const absenceApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAbsencesByDepartment: builder.query({
			query: (departmentId) => `/Absence/by-department/${departmentId}`,
			providesTags: (result, error, departmentId) => [
				{ type: "Absences", id: departmentId },
				"Absences",
			],
		}),

		getAllAbsences: builder.query({
			query: () => "/Absence",
			providesTags: ["Absences"],
		}),

		getAbsenceById: builder.query({
			query: (id) => `/Absence/${id}`,
			providesTags: (result, error, id) => [{ type: "Absences", id }],
		}),

		updateAbsence: builder.mutation({
			query: ({ id, ...absenceData }) => ({
				url: `/Absence/${id}`,
				method: "PUT",
				body: absenceData,
			}),
			invalidatesTags: ["Absences"],
		}),

		updateAbsenceStatus: builder.mutation({
			query: ({ absenceId, isExcused, reason }) => ({
				url: "/Absence/update-status",
				method: "PUT",
				body: {
					absenceId,
					isExcused,
					reason,
				},
			}),
			invalidatesTags: ["Absences"],
		}),

		createAbsence: builder.mutation({
			query: (absenceData) => ({
				url: "/Absence",
				method: "POST",
				body: absenceData,
			}),
			invalidatesTags: ["Absences"],
		}),

		deleteAbsence: builder.mutation({
			query: (id) => ({
				url: `/Absence/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Absences"],
		}),

		getAbsencesByClassLogId: builder.query({
			query: (classLogId) => `/Absence/by-classlog/${classLogId}`,
			providesTags: (result, error, classLogId) => [
				{ type: "Absences", id: `classlog-${classLogId}` },
			],
		}),

		getAbsencesByClassLogIdWithPeriod: builder.query({
			query: (classLogId) => `/Absence/by-classlog/${classLogId}/with-period`,
			providesTags: (result, error, classLogId) => [
				{ type: "Absences", id: `classlog-period-${classLogId}` },
			],
		}),

		getAbsencesByStudentIdWithPeriod: builder.query({
			query: (studentId) => `/Absence/by-student/${studentId}/with-period`,
			providesTags: (result, error, studentId) => [
				{ type: "Absences", id: `student-period-${studentId}` },
			],
		}),

		getAbsencesForDepartmentWithPeriod: builder.query({
			query: (departmentId) =>
				`/Absence/by-department/${departmentId}/with-period`,
			providesTags: (result, error, departmentId) => [
				{ type: "Absences", id: `department-period-${departmentId}` },
				"Absences",
			],
		}),

		getAbsencesByDateRangeWithPeriod: builder.query({
			query: ({ startDate, endDate, departmentId }) => {
				let url = `/Absence/by-date-range/with-period?startDate=${startDate}&endDate=${endDate}`;
				if (departmentId) {
					url += `&departmentId=${departmentId}`;
				}
				return url;
			},
			providesTags: ["Absences"],
		}),
	}),
});

export const {
	useGetAbsencesByDepartmentQuery,
	useGetAllAbsencesQuery,
	useGetAbsenceByIdQuery,
	useUpdateAbsenceMutation,
	useUpdateAbsenceStatusMutation,
	useCreateAbsenceMutation,
	useDeleteAbsenceMutation,
	useGetAbsencesByClassLogIdQuery,
	useGetAbsencesByClassLogIdWithPeriodQuery,
	useGetAbsencesByStudentIdWithPeriodQuery,
	useGetAbsencesForDepartmentWithPeriodQuery,
	useGetAbsencesByDateRangeWithPeriodQuery,
} = absenceApiSlice;
